(function () {
  // Utility: open an item (animate to its scrollHeight)
  function openItem(item) {
    const answer = item.querySelector('.faq-answer');
    const btn = item.querySelector('.faq-question');

    item.classList.add('active');
    if (btn) btn.setAttribute('aria-expanded', 'true');

    // set height to content height (use rAF for smoother painting)
    requestAnimationFrame(function () {
      // Force reading scrollHeight to ensure correct layout
      const h = answer.scrollHeight;
      answer.style.maxHeight = h + 'px';
    });

    // if answer contains images, update height after images load
    answer.querySelectorAll('img').forEach(img => {
      if (!img.complete) {
        img.addEventListener('load', () => {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }, { once: true });
      }
    });
  }

  // Utility: close an item (set maxHeight to 0)
  function closeItem(item) {
    const answer = item.querySelector('.faq-answer');
    const btn = item.querySelector('.faq-question');

    // animate collapse
    answer.style.maxHeight = answer.scrollHeight + 'px'; // set current height first
    // next frame collapse to 0 for transition
    requestAnimationFrame(() => {
      answer.style.maxHeight = '0px';
    });

    item.classList.remove('active');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  // Toggle handler used by inline onclick="toggleFAQ(this)"
  window.toggleFAQ = function (el) {
    if (!el) return;
    const faqItem = el.closest('.faq-item');
    if (!faqItem) return;

    // Close all others
    document.querySelectorAll('.faq-item').forEach(item => {
      if (item !== faqItem) {
        closeItem(item);
      }
    });

    // Toggle this one
    if (faqItem.classList.contains('active')) {
      closeItem(faqItem);
    } else {
      openItem(faqItem);
    }
  };

  // Initialize state on DOM ready: ensure aria attributes and initial heights
  function initFAQs() {
    document.querySelectorAll('.faq-item').forEach(item => {
      const btn = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      if (!btn || !answer) return;

      // Ensure buttons are accessible
      if (!btn.hasAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
      }

      // Set initial max-height for active items so animation works
      if (item.classList.contains('active')) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = '0px';
      }

      // If images inside answers load later, update heights for active items
      answer.querySelectorAll('img').forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', () => {
            if (item.classList.contains('active')) {
              answer.style.maxHeight = answer.scrollHeight + 'px';
            }
          }, { once: true });
        }
      });
    });
  }

  // Keep open item heights correct on window resize (debounced via rAF)
  let raf;
  window.addEventListener('resize', () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      document.querySelectorAll('.faq-item.active .faq-answer').forEach(a => {
        a.style.maxHeight = a.scrollHeight + 'px';
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQs);
  } else {
    initFAQs();
  }
})();